import { Snapshot } from '../types';

import { createContext } from './utils';

export interface WithSnapshot {
    snapshot: Snapshot;
    refreshSnapshot: () => Promise<void>;
    createSkill: (channelValue: string | undefined) => Promise<void>;
}

const {
    Provider,
    withContext: withSnapshot,
    Context,
} = createContext<WithSnapshot>({
    snapshot: {
        skills: [],
        operations: [],
        timezones: [],
        categories: [],
        voices: [],
        regionsWithSufficientLanguages: [],
        maxSkillsPerUser: 1000,
    },
    refreshSnapshot: () => Promise.resolve(),
    createSkill: () => Promise.resolve(),
});

export { Provider, withSnapshot, Context };
